<script lang="ts">
	export let id: string | null = null
</script>

{#if id}
	<div class="fr tr mt3">
		<small>ID: <i>{id}</i></small>
	</div>
{/if}
